import { useState } from "react";
import SectionHeading from "./SectionHeading";
import { faqs } from "@/mocks/skincare";

export default function FAQ() {
  const [openId, setOpenId] = useState<string | null>(faqs[0]?.id ?? null);

  return (
    <section className="w-full px-4 md:px-6 py-16 md:py-24">
      <div className="max-w-3xl mx-auto flex flex-col gap-10">
        <SectionHeading
          eyebrow="FAQ"
          title="자주 묻는 질문"
          description="비앙카 이용에 대해 궁금한 점을 확인해보세요."
        />

        <div className="flex flex-col gap-3">
          {faqs.map((faq) => {
            const isOpen = openId === faq.id;
            return (
              <div
                key={faq.id}
                className={`rounded-2xl border transition-colors ${
                  isOpen ? "bg-primary-50/50 border-primary-200" : "bg-background-50 border-background-200/70"
                }`}
              >
                <button
                  type="button"
                  onClick={() => setOpenId(isOpen ? null : faq.id)}
                  className="w-full flex items-center justify-between gap-4 px-6 py-5 text-left cursor-pointer"
                  aria-expanded={isOpen}
                >
                  <span className="text-base font-semibold text-foreground-900">{faq.question}</span>
                  <span
                    className={`w-8 h-8 rounded-full flex items-center justify-center shrink-0 transition-all ${
                      isOpen ? "bg-primary-500 text-white rotate-45" : "bg-primary-100 text-primary-600"
                    }`}
                  >
                    <i className="ri-add-line text-lg"></i>
                  </span>
                </button>
                {isOpen && (
                  <div className="px-6 pb-5 -mt-1">
                    <p className="text-sm text-foreground-600 leading-relaxed">{faq.answer}</p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}